<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { initSR } from '../utils/signalr'

export default {
  name: "App",

  computed: {
    ...mapGetters(["componentName"])
  },
  created() {
    // initSR() // 开启websocket服务
  }
};
</script>

<style>
/* #app {
  height: 100%;
} */
</style>
